// extracted by mini-css-extract-plugin
module.exports = {"container":"Processing_container__3cUcT","text":"Processing_text__6Pm-b"};